<template>
  <div class="ads-activity-setting">
    <el-page-header @back="goBack" :content="title">
    </el-page-header>
    <el-menu :default-active = "activeIndex"
              class = "el-menu-demo"
              mode = "horizontal"
              >
      <el-menu-item v-for = "item in componentsList"
                    :key = "item.id"
                    :index = "item.id"
                    @click = "() => {setComponents(item)}"
                    >
                    {{item.text}}
      </el-menu-item>
    </el-menu>
    <transition name="router-slid" mode="out-in">
        <keep-alive>
          <component :is="currentComponent"></component>
        </keep-alive>
    </transition>
  </div>
</template>

<script>
import adsSpace from './children/AdsSpace'
import adsNegativeKey from './children/AdsNegativeKey'
import adsNegativeProd from './children/AdsNegativeProd'

export default {
  data () {
    return {
      activeIndex: '1',
      adsType: null,
      currentComponent: 'adsSpace',
      title: "广告活动设置",
      baseList: [
        {
          id: '1',
          text: '广告位',
          name: 'adsSpace'
        },
        {
          id: '2',
          text: '否定关键词',
          name: 'adsNegativeKey'
        }
      ],
      operateList1: [
        {
          id: '3',
          text: '否定商品',
          name: 'adsNegativeProd'
        }
      ],
      componentsList: []
    }
  },
  activated(){
    // route.params.absType 1 2 自动, 4 关键词 3 5商品
    this.adsType = ['',0,0,1,0,1][this.$route.query.absType];
    this.componentsList = this.getComponentsList();
    this.setComponents(this.componentsList[0]);

    this.title = "广告活动设置->";
    this.$route.query.absType==1 && (this.title += "自动关联商品");
    this.$route.query.absType==2 && (this.title += "自动紧密匹配");
    this.$route.query.absType==3 && (this.title += "手动关联商品");
    this.$route.query.absType==4 && (this.title += "手动紧密匹配关键词");
    this.$route.query.absType==5 && (this.title += "手动亚马逊关联商品");
    this.title += "->"+this.$route.query.asin+"("+this.$route.query.name+")";
  },
  components: {
    adsSpace,
    adsNegativeKey,
    adsNegativeProd
  },
  methods: {
    goBack () {
      this.$router.go(-1);
    },
    setComponents (item) {
      this.activeIndex = item.id;
      this.currentComponent = item.name;
    },
    getComponentsList () {
      if(this.adsType < 1){
        return [...this.baseList];
      }
      return [...this.baseList, this.operateList1[this.adsType - 1]];
    }
  }
}
</script>

<style lang="scss">
  .ads-activity-setting{
  .el-page-header {
    padding: 20px 0px;
    border-bottom: solid 1px #e6e6e6;
  }

  .header-box{
    .el-button{
      width: auto;
    }
  }
  .el-menu-item {
    a{
      text-decoration: none;
    }

  }
    .el-table .cell,
    .el-table--border td:first-child .cell,
    .el-table--border th:first-child .cell {
      padding-left: 10px;
    }
  }
</style>
